import React from "react";
import MerchantMenuCategory from "./MerchantMenuCategory";

import "./Merchant.css";
import { Swiper, SwiperSlide } from "swiper/react";
import MerchantMenuList from "./MerchantMenuList";
import MerchantMenuListLoading from "../components/common/Loading/MerchantMenuListLoading";
import { categoryItemShowFilter } from "../../miscellaneous/helpers/utils";

const MerchantMenuContainer = ({ items, detailFunction, search }) => {
  const [indexCat, setIndexCat] = React.useState(0);
  const [scrolled, setIsScrolled] = React.useState(false);
  const categoryRefs = React.useRef([]);
  const swiperRef = React.useRef(null);
  const visibleCategories = React.useMemo(
    () =>
      items?.filter((category) =>
        categoryItemShowFilter({ category })
      ) || [],
    [items]
  );

  React.useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 515);

      // The category bar is 70px tall. Pick the last section which has
      // crossed just below it so the active chip follows manual scrolling.
      const activeIndex = categoryRefs.current.reduce(
        (currentIndex, section, index) =>
          section && section.getBoundingClientRect().top <= 90
            ? index
            : currentIndex,
        0
      );

      setIndexCat((currentIndex) =>
        currentIndex === activeIndex ? currentIndex : activeIndex
      );
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, [visibleCategories.length]);

  React.useEffect(() => {
    swiperRef.current?.slideTo(indexCat);
  }, [indexCat]);

  const scrollToCategory = (index) => {
    setIndexCat(index);
    const section = categoryRefs.current[index];
    if (!section) return;

    const categoryBarOffset = scrolled ? 70 : 80;
    const top = section.getBoundingClientRect().top + window.pageYOffset;
    window.scrollTo({ top: top - categoryBarOffset, behavior: "smooth" });
  };

  let x = [
    !search
      ? "merchant-menu-container merchant-menu-container-absolute"
      : "merchant-menu-container merchant-menu-container-absolute",
  ];
  if (scrolled) {
    x.splice(
      x.findIndex(
        (className) =>
          className ===
          "merchant-menu-container merchant-menu-container-absolute"
      ),
      1,
      "merchant-menu-container merchant-menu-container-fixed"
    );
  }
  return (
    <>
      <div className={x.join(" ")}>
        <Swiper
          onSwiper={(swiper) => {
            swiperRef.current = swiper;
          }}
          breakpoints={{
            500: {
              // width: 500,
              slidesPerView: 5,
            },
            425: {
              // width: 425,
              slidesPerView: 4,
            },
            375: {
              // width: 375,
              slidesPerView: 4,
            },
            320: {
              // width: 320,
              slidesPerView: 3,
            },
            280: {
              // width: 280,
              slidesPerView: 2,
            },
          }}
        >
          {!items ? (
            // <span>{t.loading}</span>
            <div className="merchant-menu-category-loading">
              <div className="merchant-menu-category-loading-component loading"></div>
              <div className="merchant-menu-category-loading-component loading"></div>
              <div className="merchant-menu-category-loading-component loading"></div>
              <div className="merchant-menu-category-loading-component loading"></div>
            </div>
          ) : (
            visibleCategories.map((catItems, index) => (
              <SwiperSlide key={catItems.id || catItems.name}>
                <MerchantMenuCategory
                  active={index === indexCat}
                  onClick={() => scrollToCategory(index)}
                  items={catItems}
                  detailFunction={detailFunction}
                />
              </SwiperSlide>
            ))
          )}
        </Swiper>
      </div>
      <div
        style={{
          backgroundColor: "#ffffff",
          borderTopRightRadius: 8,
          borderTopLeftRadius: 8,
          width: "100%",
          minHeight: "calc(100vh - 200px)",
          paddingTop: 70,
        }}
      >
        <div
          className="menu-menu-list-container"
          style={{ height: "100%", marginBottom: 60 }}
        >
          {!items ? (
            // <span>{t.loading}</span>
            <>
              <MerchantMenuListLoading />
              <MerchantMenuListLoading />
              <MerchantMenuListLoading />
              <MerchantMenuListLoading />
            </>
          ) : visibleCategories.length > 0 ? (
            visibleCategories.map((category, categoryIndex) => (
              <section
                className="merchant-menu-category-section"
                key={category.id || category.name}
                ref={(element) => {
                  categoryRefs.current[categoryIndex] = element;
                }}
              >
                <h2 className="merchant-menu-category-title">
                  {category.name}
                </h2>
                <div className="merchant-menu-category-items">
                  {category.items?.map((menuItem) => (
                    <MerchantMenuList
                      key={menuItem.id}
                      item={menuItem}
                      detailFunction={detailFunction}
                      categoryName={category.name}
                    />
                  ))}
                </div>
              </section>
            ))
          ) : null}
          {items && visibleCategories.length === 0 && (
            <div className="merchant-menu-list-container">
              <div className="merchant-menu-list-wrapper">&nbsp; Not found</div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default MerchantMenuContainer;
